export default {"src":"/_next/static/media/Translate.612090c2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};